import React from "react";
import ReactDOM from "react-dom/client";
import DnDCharacterSheet from "./DnDCharacterSheet";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<DnDCharacterSheet />
	</React.StrictMode>
);
